var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-header',{attrs:{"height":"100"}},[_c('Header')],1),_c('el-main',[_c('router-view')],1),_c('el-footer',[_c('div',{staticClass:"footer-info"},[_vm._v(" Copyright © 2018-2024 心里有光 All Rights Reserved. 备案号："),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("粤ICP备2023117501号-1")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }